import { useEffect, useMemo, useState } from "react";

import { useQuery } from "react-query";
import { Selection } from "office-ui-fabric-react/lib/DetailsList";
import { getReasons, getReasonsById } from "../../../connectors/cancellationReasons/connectors";
import { dictionaryTypes, translateDictionaryName } from "../actions/dictionaryNames";
import { useTranslation } from 'react-i18next';

export const useReasonsList = (onSelection?: any, onInvoke?: any) => {
  const { t } = useTranslation('admin');
  const {data} = useQuery("reasons", getReasons)
  // Values translated by the API (for display only); key starts with "reasons" so the existing invalidation refreshes it too
  const { data: translatedValues } = useQuery(["reasons", "translated"], async () => {
    const responses = await Promise.all(dictionaryTypes.map((type) => getReasonsById("", type.toString())));
    const byId: { [id: number]: string } = {};
    responses.forEach((res: any) => res.data.data.forEach((value: any) => { byId[value.id] = value.value; }));
    return byId;
  });
  const [groups, setGroups] = useState<any>([]);
  const [items, setItems] = useState<any>([]);
  const fetchedData = useMemo(() => {
    if (data) {
      return data
    } else return "";
  }, [data]);

  useEffect(() => {
    if(data){
      generateGroups(data.data.data);
      generateItems(data.data.data);
    }
  }, [JSON.stringify(fetchedData), t]);


  const generateGroups = (items: Array<any>) => {
    let index = 0;
    const gr = items.map((item: any) => {
      const grItem = {
        name: translateDictionaryName(item.name, t),
        count: item.values.length,
        key: item.name,
        startIndex: index,
      };
      index += item.values.length;
      return grItem;
    });

    setGroups(gr);
  };

  const generateItems = (items: Array<any>) => {
    const arr: Array<any> = [];
    items.forEach((item: any) => {
      const parsedItems = item.values.map((item: any) => {
        return{
          ...item,
          reason: item.value
        }
      })
      
      arr.push(...parsedItems);
    });

    setItems(arr);
  };
  

  const columns = useMemo(
    () => [
      {
        key: "reason",
        name: t('cancellationReasons.columns.reason'),
        fieldName: "reason",
        minWidth: 300,
        maxWidth: 500,
        isResizable: true,
        // item.reason stays untranslated - it is the value edited and saved
        onRender: (item: any) => (translatedValues && translatedValues[item.id]) || item.reason,
      },
    ],
    [t, translatedValues]
  );

  const selection = useMemo(
    () =>
      new Selection({
        onSelectionChanged: () => {
          if (onSelection) {
            onSelection(selection.getSelection());
          }
        },
      }),
    []
  );

  const handleInvoke = (item: any) => {
    if (onInvoke) {
      onInvoke();
    }
  };

  return {
    groups,
    items,
    columns,
    selection,
    handleInvoke,
  };
};
